export default "__VITE_ASSET__B_xwWxtb__"